<template>
  <div class="adm-form">
    <div class="adm-form-head">
      <div>
        <span class="adm-form-kicker"><tkd-icon name="section"/> Відділення</span>
        <h4 class="adm-form-title">{{ formAddCategory.id ? 'Редагувати відділення' : 'Нове відділення' }}</h4>
      </div>
      <button type="button" class="adm-form-close" @click="saveCategoryClose()" title="Закрити" aria-label="Закрити"><tkd-icon name="close"/></button>
    </div>

    <div class="adm-form-body">
      <section class="adm-section">
        <h5 class="adm-section-title"><tkd-icon name="notes"/> Основне</h5>
        <div class="adm-form-grid">
          <div class="adm-field adm-span-all" :class="{ 'has-error': errors.name }">
            <label class="adm-label" for="section-name">Назва відділення <span class="adm-req">*</span></label>
            <input id="section-name" ref="nameInput" class="adm-input" type="text"
                   v-model="formAddCategory.name"
                   placeholder="Наприклад: Татамі 1, ранок"
                   @input="clearError('name')"
                   @keyup.enter="saveCategoryAndAdd()">
            <div class="adm-field-error" v-if="errors.name">{{ errors.name }}</div>
          </div>

          <div class="adm-field adm-span-2" :class="{ 'has-error': errors.start_number }">
            <label class="adm-label" for="section-start">Номер першого поєдинку</label>
            <input id="section-start" class="adm-input" type="number" min="0" step="1"
                   v-model="formAddCategory.start_number"
                   placeholder="0"
                   @input="clearError('start_number')"
                   @keyup.enter="saveCategoryAndAdd()">
            <div class="adm-field-error" v-if="errors.start_number">{{ errors.start_number }}</div>
            <div class="section-hint" v-else>З цього номера почнеться нумерація поєдинків відділення.</div>
          </div>
        </div>
      </section>

      <section class="adm-section" v-if="formAddCategory.id">
        <h5 class="adm-section-title"><tkd-icon name="settings"/> Дії з відділенням</h5>
        <div class="section-tools">
          <div class="section-tool">
            <div>
              <b>Нумерація поєдинків</b>
              <span>Перезапише всі попередні номери в цьому відділенні.</span>
            </div>
            <button type="button" class="adm-btn adm-btn-sm" @click="numerationClose()" :disabled="isSaving"><tkd-icon name="numbering"/> Пронумерувати</button>
          </div>
          <div class="section-tool">
            <div>
              <b>Документ відділення</b>
              <span>PDF зі списком поєдинків.</span>
            </div>
            <a target="_blank" rel="noopener" class="adm-btn adm-btn-sm"
               :href="'https://app.taekwondo.com.ua/tournament-result/print-section-pdf?id='+formAddCategory.id+'&tid='+tournamentOne.data.item.id"><tkd-icon name="file"/> Скачати PDF</a>
          </div>
          <div class="section-tool danger">
            <div>
              <b>Видалити відділення</b>
              <span>Дію не можна скасувати.</span>
            </div>
            <button type="button" class="adm-btn adm-btn-sm adm-btn-danger" @click="deleteSection()" :disabled="isSaving"><tkd-icon name="trash"/> Видалити</button>
          </div>
        </div>
      </section>
    </div>

    <div class="adm-form-foot">
      <span class="adm-form-summary" v-if="errorCount">Заповніть обовʼязкові поля ({{ errorCount }})</span>
      <div class="adm-form-foot-actions">
        <button type="button" class="adm-btn" @click="saveCategoryClose()">Скасувати</button>
        <button type="button" class="adm-btn adm-btn-primary" @click="saveCategoryAndAdd()" :disabled="isSaving">
          <tkd-icon :name="isSaving ? 'loader' : 'save'"/> {{ isSaving ? 'Збереження…' : 'Зберегти' }}
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import 'src/assets/css/tkd-theme.css';
import 'src/assets/css/tkd-admin.css';

export default {
  name: "form-category",
  props: ['formAddCategory'],

  data() {
    return {
      errors: {},
      isSaving: false,
    }
  },

  computed: {
    tournamentOne() {
      return this.$store.getters['tournament/tournamentOne'];
    },
    errorCount() {
      return Object.keys(this.errors).length;
    },
  },

  mounted() {
    // модалка монтує форму при кожному відкритті — фокус на назву
    this.$nextTick(() => this.$refs.nameInput && this.$refs.nameInput.focus());
  },

  methods: {
    clearError(field) {
      if (this.errors[field]) {
        this.$delete(this.errors, field);
      }
    },

    validate() {
      let errors = {};
      if (!String(this.formAddCategory.name || '').trim()) {
        errors.name = 'Вкажіть назву відділення';
      }
      const start = this.formAddCategory.start_number;
      if (start !== '' && start !== null && start !== undefined && !(Number(start) >= 0)) {
        errors.start_number = 'Номер має бути цілим числом від 0';
      }
      this.errors = errors;
      return !Object.keys(errors).length;
    },

    successfulSaved() {
      this.$notify({
        text: 'Відділення збережено',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        duration: 10000,
        speed: 1000,
        type: 'success'
      });
    },

    faileSaved(error) {
      const responseMessage = error && error.response && error.response.data
        ? error.response.data.message || error.response.data.error
        : '';

      this.$notify({
        text: responseMessage || 'Помилка. Відділення не збережено',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        duration: 10000,
        speed: 1000,
        type: 'error'
      });
    },

    successfulDeleted() {
      this.$notify({
        text: 'Відділення видалено',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        duration: 10000,
        speed: 1000,
        type: 'success'
      });
    },

    failedDeleted(error) {
      const responseMessage = error && error.response && error.response.data
        ? error.response.data.message || error.response.data.error
        : '';

      this.$notify({
        text: responseMessage || 'Помилка. Відділення не видалено',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        duration: 10000,
        speed: 1000,
        type: 'error'
      });
    },


    saveCategoryClose() {
      this.$modal.hide('section-form-modal');
    },


    numerationClose() {
      // модалку закриваємо лише після підтвердження
      if (!window.confirm("Ви впевнені, що хочете пронумерувати поєдинки? Всі попередні номера в даному відділенні будуть стерті")) {
        return;
      }

      var params = Object.assign({}, this.formAddCategory);
      const tournamentId = this.tournamentOne.data.item.id;
      this.isSaving = true;

      this.$store.dispatch('tournament_section/fightNumeration', params)
        // раніше тут був {id: params.tournament_id} (undefined) і неіснуючий this.updateBracket()
        .then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: tournamentId}))
        .then(() => {
          this.$notify({
            text: 'Поєдинки пронумеровано',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 10000,
            speed: 1000,
            type: 'success'
          });
          this.saveCategoryClose();
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    saveCategoryAndAdd() {
      this.saveCategory(false);
    },

    saveCategoryAndClose() {
      this.saveCategory(true);
    },

    deleteSection() {
      if (!this.formAddCategory.id) {
        return;
      }

      if (window.confirm("Після видалення дані неможливо буде відновити. Ви впевнені, що хочете видалити відділення?")) {
        const params = {id: this.formAddCategory.id};
        this.isSaving = true;

        this.$store.dispatch('tournament_section/deleteSection', params)
          .then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id}))
          .then(() => {
            this.successfulDeleted();
            this.saveCategoryClose();
          })
          .catch(error => {
            this.failedDeleted(error);
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },


    saveCategory(close) {
      if (this.isSaving || !this.validate()) {
        return;
      }

      var params = Object.assign({}, this.formAddCategory);

      params.sectionid = this.formAddCategory.id == undefined ? 0 : this.formAddCategory.id;
      params.tournament_id = this.tournamentOne.data.item.id;

      this.isSaving = true;

      this.$store.dispatch('tournament_section/addSection', params)
        .then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id}))
        .then(() => {
          this.successfulSaved();
          this.saveCategoryClose();
        })
        .catch(error => {
          this.faileSaved(error);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },

  }
}
</script>

<style scoped>
.section-hint { margin-top: 5px; font-size: 12px; color: var(--tkd-muted); }

.section-tools { display: flex; flex-direction: column; gap: 8px; margin-bottom: 12px; }

.section-tool {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid var(--tkd-border);
  border-radius: var(--tkd-radius);
  background: var(--tkd-bg);
}

.section-tool b { display: block; font-size: 14px; color: var(--tkd-text); }
.section-tool span { font-size: 12px; color: var(--tkd-muted); }
.section-tool.danger { border-color: var(--adm-danger-border); background: var(--adm-danger-bg); }
</style>
